import { Store } from 'redux';
import { IStoreState } from '../types';
import { Dispatch } from 'react';
import Axios from 'axios';

import { fireNotification } from '../actions/Notification.action';
import Variant from '../types/Variant.type';
import { PATH } from '../constants/Path.constant';
import {
  IWithdrawAssetAction,
  IWithdrawAssetApprovedAction,
  IWithdrawSavingApprovedAction
} from '../actions/withdrawAsset.action';
import {
  WITHDRAW_ASSET_ACTION,
  WITHDRAW_ASSET_APPROVED_ACTION,
  WITHDRAWAL_TYPE,
  WITHDRAW_SAVING_APPROVED_ACTION
} from '../constants/withdrawAsset.constant';
import { MESSAGE_NOTIFICATION_ERROR } from '../constants/Notification.constant';

export const withdrawAssetMiddleware = (store: Store<IStoreState>) => (
  dispatch: Dispatch<
    | IWithdrawAssetAction
    | IWithdrawAssetApprovedAction
    | IWithdrawSavingApprovedAction
  >
) => async (
  action:
    | IWithdrawAssetAction
    | IWithdrawAssetApprovedAction
    | IWithdrawSavingApprovedAction
) => {
  switch (action.type) {
    case WITHDRAW_ASSET_ACTION: {
      Axios.post(`/withdraw`, action.payload)
        .then(() => {
          store.dispatch(
            fireNotification({
              message: `Please check your inbox for a confirmation email.`,
              variant: Variant.SUCCESS,
              link: PATH.nexo.account
            })
          );
        })
        .catch(err => {
          const error =
            err?.response?.data?.error?.message?.message ||
            err?.response?.data?.error?.message ||
            MESSAGE_NOTIFICATION_ERROR.EDIT_PROFILE;
          store.dispatch(
            fireNotification({
              message: error,
              variant: Variant.ERROR
            })
          );
        });
      break;
    }

    case WITHDRAW_ASSET_APPROVED_ACTION: {
      Axios.post(`/withdraw/approve`, {
        token: action.payload,
        withdrawalType: WITHDRAWAL_TYPE.ASSET
      })
        .then(() => {
          store.dispatch(
            fireNotification({
              message: ` Withdraw Asset Approve Successfully`,
              variant: Variant.SUCCESS,
              link: PATH.nexo.account
            })
          );
        })
        .catch(err => {
          const error =
            err?.response?.data?.error?.message?.message ||
            err?.response?.data?.error?.message ||
            MESSAGE_NOTIFICATION_ERROR.EDIT_PROFILE;
          store.dispatch(
            fireNotification({
              message: error,
              variant: Variant.ERROR
            })
          );
        });
      break;
    }
    case WITHDRAW_SAVING_APPROVED_ACTION: {
      Axios.post(`/withdraw/approve`, {
        token: action.payload,
        withdrawalType: WITHDRAWAL_TYPE.SAVING
      })
        .then(() => {
          store.dispatch(
            fireNotification({
              message: ` Withdraw Saving Approve Successfully`,
              variant: Variant.SUCCESS,
              link: PATH.nexo.transactions
            })
          );
        })
        .catch(err => {
          const error =
            err?.response?.data?.error?.message?.message ||
            err?.response?.data?.error?.message ||
            MESSAGE_NOTIFICATION_ERROR.EDIT_PROFILE;
          store.dispatch(
            fireNotification({
              message: error,
              variant: Variant.ERROR
            })
          );
        });
      break;
    }
  }
  return dispatch(action);
};
